import { render, staticRenderFns } from "./ModalProjectDetail.vue?vue&type=template&id=0cf36f9e&lang=pug&"
import script from "./ModalProjectDetail.vue?vue&type=script&lang=js&"
export * from "./ModalProjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalProjectDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports